import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

function ConfidentialProject() {
  return (
    <section className="under-dev-page">
      <div className="under-dev-orb under-dev-orb-one" aria-hidden="true" />
      <div className="under-dev-orb under-dev-orb-two" aria-hidden="true" />
      <div className="under-dev-grid" aria-hidden="true" />

      <div className="under-dev-content">
        <span className="under-dev-eyebrow">Edustrix</span>
        <h1 className="under-dev-title">Internal Project</h1>
        <p className="under-dev-copy">
          This demo is confidential and available only to authorized internal
          reviewers. Reach out if you need access.
        </p>
        <div className="under-dev-meta">
          <span>Access: Internal Only</span>
          <span>Visibility: Confidential</span>
          <span>Status: Restricted</span>
        </div>
        <div className="under-dev-actions">
          <Button as={Link} to="/project" variant="primary">
            Back to Projects
          </Button>
        </div>
      </div>
    </section>
  );
}

export default ConfidentialProject;
